/**
 * Directive: screenReaderNavSelected
 */
angular.module('acme.common.directive.screenReaderNavSelected', [])
.directive('screenReaderNavSelected', [function() {

    return {
      restrict: 'A',
      replace: true,
      templateUrl: 'common/directives/screenReaderNavSelected/screenReaderNavSelected.tpl.html',
      scope: {},
      link: function($scope, $element, $attrs) {
        // Modified after controller runs
      },

      controller: ['$scope', function($scope) {

        $scope.screenReaderNavSelected = "Your spankin new screenReaderNavSelected!";

      }]

    };

}]);

